import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import * as localeLib from 'date-fns/locale';
import { isFutureTime, rmLocaleToDateFnLocale } from '@brighterion/utils/dates-helpers';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import 'react-datepicker/dist/react-datepicker.css';
import { Icon } from '@brighterion/br-ui';

interface Props {
    selected: Date;
    onChange: (date: any) => void;
    disabled: boolean;
    showIcon?: boolean;
}

const DatePickerWrapper = ({ selected, onChange, disabled, showIcon = false }: Props) => {
    const { locale } = useTemplateStore.getState().template;
    const localeString = rmLocaleToDateFnLocale(locale);
    // @ts-ignore - a bit hacky but we are assuming that the locale in user config is a valid locale string
    registerLocale('datePickerLocale', localeLib[localeString]);
    return (
        <DatePicker
            selected={selected}
            onChange={onChange}
            locale='datePickerLocale'
            dateFormat='Pp'
            timeFormat='p'
            minDate={new Date()}
            filterTime={isFutureTime}
            disabled={disabled}
            showTimeInput
            customTimeInput={<></>}
            timeInputLabel=''
            showIcon={showIcon}
            icon={<Icon name='calendar-small' size='sm' />}
        />
    );
};

export default DatePickerWrapper;
